// RagDot — facility health status as a small filled circle.
// 10px default, 12px lg. The "none" state renders an outlined circle so
// missing data is visible but doesn't shout for attention.
//
// Color logic comes from RAG_COLORS in design-tokens. The corresponding
// utility classes (.rag-dot.g/.a/.r) also exist in tcs.css; this component
// uses inline styles so consumers can color it from data without a class lookup.

import type { RagStatus } from '../types';
import { RAG_COLORS, ragLabel } from '../design-tokens';

export interface RagDotProps {
  status: RagStatus | null;
  /** Default 'md' = 10px, 'lg' = 12px. */
  size?: 'md' | 'lg';
  /** Optional className for spacing/positioning. */
  className?: string;
}

export function RagDot({ status, size = 'md', className }: RagDotProps) {
  const dim = size === 'lg' ? 12 : 10;
  const style = {
    width: dim,
    height: dim,
    backgroundColor: status ? RAG_COLORS[status] : undefined,
  };
  if (!status) {
    return (
      <span
        className={`inline-block shrink-0 rounded-full border border-tcs-border-strong ${className ?? ''}`}
        style={{ width: dim, height: dim }}
        aria-label="No RAG status"
      />
    );
  }
  return (
    <span
      className={`inline-block shrink-0 rounded-full ${className ?? ''}`}
      style={style}
      aria-label={`RAG: ${ragLabel[status]}`}
      title={`RAG: ${ragLabel[status]}`}
    />
  );
}
